export const numberFormat = new Intl.NumberFormat("en-US");

export const GetOffset = (el) => {
  let x = 0;
  let y = 0;
  while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
    x += el.offsetLeft - el.scrollLeft;
    y += el.offsetTop - el.scrollTop;
    el = el.offsetParent;
  }
  return { top: y, left: x };
};

export const pattern = {
  email: "^[a-zA-Z0-9.+-_,&]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$",
  name: "^[a-zA-Z]{0,28}[ ][a-zA-Z]{0,28}$",
  // /^\w+[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
};

export const CheckValue = (value) =>
  value !== null &&
  value !== undefined &&
  value !== "null" &&
  value !== "undefined" &&
  value !== "NaN" &&
  !Number.isNaN(value);

  // Unique Id
export const generateUniqueID = (length = 10) => {
  const lowercase = "abcdefghijklmnopqrstuvwxyz";
  const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const digits = "0123456789";
  // const symbols = "!@#$%^&*()_+[]{}|;:,.<>?";
  const all = lowercase + uppercase + digits;

  const getRandom = (chars) => chars[Math.floor(Math.random() * chars.length)];

  // Ensure one of each type
  const password = [
    getRandom(lowercase),
    getRandom(uppercase),
    getRandom(digits),
  ];

  for (let i = password.length; i < length; i++) {
    password.push(getRandom(all));
  }

  // Shuffle the characters
  return password.sort(() => Math.random() - 0.5).join("");
};
// Unique Id

export const setFilter = (
  keyName,
  value,
  parent,
  showInFilter = true,
  type='string'
) => ({
  keyName,
  value,
  parent,
  showInFilter,
  type
});
